export const environment = {
  production: false,
  baseURL: 'https://dev-bo.nutridayquocte.com/api',
  imageURL: 'https://dev-bo.nutridayquocte.com/api/files',
  timeInterval: 30000,
};
